import React from 'react';
import {Button, Paper, Grid, Typography} from "@mui/material";
import {makeStyles} from '@mui/styles';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Preloader from '../Preloader/Preloader';
const {siteUrl}=window;

const useStyles = makeStyles(() => ({
	cardWrapper: {
		marginBottom: '50px',
	},

	card: {
		margin: 0,
		display: 'grid',
		gridTemplateColumns: '33.333% 1fr',
		'@media (max-width: 1024px)': {
			display: 'block',
		},
	},

	// card slider
	cardSlider: {
		position: 'relative',
		backgroundColor: '#333',
		userSelect: 'none',
	},

	cardSliderItem: {
		position: 'relative',
		width: '100%',
		height: '100%',
		minHeight: '280px',

		"&:before": {
			content: '""',
			display: 'block',
			paddingBottom: '93.9%'
    	},
		'@media (max-width: 1024px)': {
			"&:before": {
				paddingBottom: '50%'
	 		},
		},
	},

	cardSliderImage: {
		position: 'absolute',
		top: '0',
		left: '0',
		width: '100%',
		height: '100%',
		objectFit: 'cover'
	},

	content: {
		display: 'grid',
		gridTemplateRows: 'auto 1fr',
		'@media (max-width: 1024px)': {
			padding: '30px',
		},
	},

	header: {
		padding: '10px 15px',
		borderBottom: '1px solid #C0C0C0',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		'@media (max-width: 1024px)': {
			display: 'none'
		},
	},

	body: {
		padding: '15px 0',
		display: 'grid',
		gridTemplateColumns: 'repeat(2, 1fr)',
		'@media (max-width: 1024px)': {
			display: 'block',
			padding: '0px'
		},
	},

	column: {
		position: 'relative',
		fontSize: '16px',
		padding: '3px 20px',
		'&:first-child': {
			borderRight: '1px solid #C0C0C0',
		},
		'&:last-child': {
			gridTemplateRows: '1fr auto',
			display: 'grid'
		},
		'@media (max-width: 1024px)': {
			padding: '0px',
			'&:first-child': {
				paddingBottom: '20px',
				marginBottom: '12px',
				borderRight: 'none',
				borderBottom: '1px solid #C0C0C0',
			},
		},
	},

	extraList: {
		padding: '0 10px',
		margin: '0 0 20px 0',

		'@media (max-width: 1024px)': {
			gap: '25px 15px',
			maxWidth: '440px',
			margin: '0 auto 20px auto'
		},
		'@media (max-width: 600px)': {
			maxWidth: 'unset',
		},
	},


	extraText: {
		fontSize: '16px',
	},
}));

const CardTripAccordionLoader = () => {
	const classes = useStyles();
	return (
		<Paper elevation={3} className={classes.cardWrapper}>
			<div className={classes.card}>
				<div className={classes.cardSlider}>
					<div className={classes.cardSliderItem}/>
				</div>
				<div className={classes.content}>
					<div className={classes.header}>
						<Typography
							gutterBottom
							variant="h3"
							component="h3"
							sx={{fontSize: '21px', margin: 0}}
						>
							<strong>Trips Loading...</strong>
							<br/>
							<strong style={{fontSize:'13px'}}>Please wait while we load available trips</strong>
						</Typography>
					</div>
					<div className={classes.body}>
						<div className={classes.column}>
							TRIP LOADING...
							<Preloader/>
						</div>
						<div className={classes.column}>
							<div className={classes.extraList}>
								<span className={classes.extraText}>EXTRA LIST LOADING...</span>
							</div>
							<Grid item sx={{margin: 0, padding: 0}}>
								<Button
									sx={{
										marginBottom: '10px',
										position: 'relative',
										fontWeight: 500,
										width:'100%',
										boxShadow:'none',
										backgroundColor: '#F3F3F3',
										color: '#000',
										":hover":{
											backgroundColor: '#C0C0C0',
										}
									}}
									variant={'contained'}
									fullWidth
								>
									TRIP LOADING...
									<KeyboardArrowDownIcon
										sx={{
											fontSize: '25px !important',
											position: 'absolute',
											right: '20px',
											top: '9px',
											transition: 'transform 0.3s ease',
										}}
									/>
								</Button>
							</Grid>
						</div>
					</div>
				</div>
			</div>
		</Paper> 
	);
};

export default CardTripAccordionLoader;